module.exports = __webpack_public_path__ + "690c4009.png";